import { Building2, Users, Shield, Truck, Star } from "lucide-react";

// ── Storage Keys ──────────────────────────────────────────────────────────────
export const MARKET_TOKEN_KEY = "hylas_market_token";
export const MARKET_TERMS_KEY = "hylas_market_terms";

// ── Color Palette ─────────────────────────────────────────────────────────────
export const ACCENT       = "#FF4D00";
export const GOLD         = "#F5C842";
export const DARK         = "#0A0A0A";
export const CARD         = "#161618";
export const MID          = "#1C1C1E";
export const GREEN_SUCCESS = "#22c55e";

// ── Hub Configuration ─────────────────────────────────────────────────────────
export const HUB_META = {
  carrier:   { icon: Building2, label: "Carriers",   accent: "#FF4D00", glow: "255,77,0",    desc: "Bid on drivers",    badge: "HIRING",     badgeBg: "rgba(255,77,0,0.15)" },
  recruiter: { icon: Users,     label: "Recruiters", accent: "#F5C842", glow: "245,200,66",  desc: "Manage pipeline",   badge: "TALENT",     badgeBg: "rgba(245,200,66,0.15)" },
  safety:    { icon: Shield,    label: "Safety",     accent: "#38BDF8", glow: "56,189,248",  desc: "Vet & approve",     badge: "COMPLIANCE", badgeBg: "rgba(56,189,248,0.15)" },
  driver:    { icon: Truck,     label: "Drivers",    accent: "#4ADE80", glow: "74,222,128",  desc: "Your market value", badge: "PROFILES",   badgeBg: "rgba(74,222,128,0.15)" },
  admin:     { icon: Star,      label: "Admin",      accent: "#A78BFA", glow: "167,139,250", desc: "Full access",       badge: "SYSTEM",     badgeBg: "rgba(167,139,250,0.15)" },
};
export const HUB_ORDER = ["carrier", "recruiter", "safety", "driver"];

// ── Framer Motion Variants ────────────────────────────────────────────────────
export const FADE_UP = {
  hidden: { opacity: 0, y: 28 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.52, ease: [0.22, 1, 0.36, 1] } },
};
export const STAGGER_CONTAINER = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.065 } },
};
export const CARD_VARIANT = {
  hidden: { opacity: 0, y: 38, scale: 0.96 },
  show:   { opacity: 1, y: 0,  scale: 1,    transition: { duration: 0.48, ease: [0.22, 1, 0.36, 1] } },
};
export const SLIDE_LEFT = {
  hidden: { opacity: 0, x: -28 },
  show:   { opacity: 1, x: 0,  transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1] } },
};
export const MODAL_BG = {
  hidden: { opacity: 0 },
  show:   { opacity: 1 },
  exit:   { opacity: 0 },
};
export const MODAL_PANEL = {
  hidden: { opacity: 0, scale: 0.92, y: 28 },
  show:   { opacity: 1, scale: 1,    y: 0,  transition: { duration: 0.34, ease: [0.22, 1, 0.36, 1] } },
  exit:   { opacity: 0, scale: 0.95, y: 16, transition: { duration: 0.22 } },
};

// ── CSS Keyframe Animations ───────────────────────────────────────────────────
export const MARKET_CSS = `
  @keyframes hm-shimmer {
    0%   { transform: translateX(-100%) skewX(-15deg); }
    100% { transform: translateX(300%)  skewX(-15deg); }
  }
  @keyframes hm-scanline {
    0%   { transform: translateY(-100%); }
    100% { transform: translateY(100vh); }
  }
  @keyframes hm-grain {
    0%,100% { transform: translate(0,0); }
    10%     { transform: translate(-2%,-3%); }
    20%     { transform: translate(3%, 2%); }
    30%     { transform: translate(-1%, 4%); }
    40%     { transform: translate(4%,-1%); }
    50%     { transform: translate(-3%, 3%); }
    60%     { transform: translate(2%, -2%); }
    70%     { transform: translate(-4%, 1%); }
    80%     { transform: translate(1%,  3%); }
    90%     { transform: translate(-2%, -4%); }
  }
  @keyframes hm-float {
    0%,100% { transform: translateY(0px) rotate(0deg);    opacity: 0.6; }
    33%     { transform: translateY(-18px) rotate(120deg); opacity: 1;   }
    66%     { transform: translateY(-8px) rotate(240deg);  opacity: 0.7; }
  }
  @keyframes hm-pulse-ring {
    0%   { transform: scale(1);   opacity: 0.8; }
    100% { transform: scale(2.5); opacity: 0; }
  }
  @keyframes hm-gold-sweep {
    0%   { left: -60%; }
    100% { left: 140%; }
  }
  @keyframes hm-bid-flash {
    0%   { background: rgba(255,77,0,0.35); }
    100% { background: transparent; }
  }
  @keyframes hm-title-glow {
    0%,100% { text-shadow: 0 0 80px rgba(255,77,0,0.4), 0 0 160px rgba(255,77,0,0.15); }
    50%     { text-shadow: 0 0 120px rgba(255,77,0,0.65), 0 0 240px rgba(255,77,0,0.25), 0 0 40px rgba(245,200,66,0.2); }
  }
  @keyframes hm-border-glow {
    0%,100% { border-color: rgba(255,77,0,0.25); box-shadow: 0 0 0px rgba(255,77,0,0); }
    50%     { border-color: rgba(255,77,0,0.55); box-shadow: 0 0 18px rgba(255,77,0,0.18); }
  }
`;
